var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "LayoutBase",
    { attrs: { "has-fixed-group": true } },
    [
      _c("header", { attrs: { id: "content__header" } }, [
        _vm.resource.country
          ? _c("img", {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: _vm.resource.country.name,
                  expression: "resource.country.name",
                },
              ],
              staticClass: "flag",
              attrs: { src: _vm.resource.country.flag },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("h1", [_vm._v(_vm._s(_vm.resource.projectName))]),
        _vm._v(" "),
        _vm.resource.urgent
          ? _c("span", { staticClass: "pill pill--urgent" }, [_vm._v("Urgent")])
          : _vm._e(),
        _vm._v(" "),
        _vm.resource.respondBy
          ? _c("span", { staticClass: "respond-by" }, [
              _vm._v(_vm._s(_vm.respondBy)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "actions" },
          [
            _vm.resource.can.edit
              ? _c(
                  "router-link",
                  {
                    staticClass: "btn btn--outline",
                    attrs: {
                      to: {
                        name: "share-opportunity",
                        params: { opportunity_id: _vm.resource.id },
                      },
                    },
                  },
                  [_vm._v("Share\n                ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.resource.can.edit
              ? _c(
                  "router-link",
                  {
                    staticClass: "btn btn--primary",
                    attrs: {
                      to: {
                        name: "opportunity-preview",
                        params: { opportunity_id: _vm.resource.id },
                      },
                    },
                  },
                  [_vm._v("Edit\n                ")]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "company-info" }, [
        _vm.resource.companyName
          ? _c("h2", [_vm._v(_vm._s(_vm.resource.companyName))])
          : _vm._e(),
        _vm._v(" "),
        _c("ul", { staticClass: "grid post-details" }, [
          _vm.resource.createdAt
            ? _c("li", { staticClass: "col-6 col-md-3 detail" }, [
                _c("span", { staticClass: "label" }, [_vm._v("Posted")]),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "h3" },
                  [
                    _c("SvgIcon", { attrs: { icon: "calendar" } }),
                    _vm._v(" " + _vm._s(_vm.resource.createdAt)),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.resource.website
            ? _c("li", { staticClass: "col-6 col-md-3 detail" }, [
                _c("span", { staticClass: "label" }, [_vm._v("Website")]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "h3",
                    attrs: { href: _vm.resource.website, target: "_blank" },
                  },
                  [
                    _c("SvgIcon", { attrs: { icon: "link" } }),
                    _vm._v(" Click here"),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("li", { staticClass: "col-6 col-md-3 detail" }, [
            _c("span", { staticClass: "label" }, [_vm._v("Opportunity Type")]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "h3" },
              [
                _c("SvgIcon", { attrs: { icon: "lock" } }),
                _vm._v(
                  " " +
                    _vm._s(_vm.resource.mandated ? "Mandated" : "Non-Mandated")
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _vm.resource.dealType
            ? _c("li", { staticClass: "col-6 col-md-3 detail" }, [
                _c("span", { staticClass: "label" }, [_vm._v("Deal Type")]),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "h3" },
                  [
                    _c("SvgIcon", { attrs: { icon: "deal" } }),
                    _vm._v(" " + _vm._s(_vm.resource.dealType)),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.resource.location
            ? _c("li", { staticClass: "col-6 col-md-3 detail" }, [
                _c("span", { staticClass: "label" }, [
                  _vm._v("Location of Activities"),
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "h3" },
                  [
                    _c("SvgIcon", { attrs: { icon: "location" } }),
                    _vm._v(" " + _vm._s(_vm.resource.location)),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("section", { staticClass: "deal-info" }, [
        _c("ul", { staticClass: "grid post-details" }, [
          _vm.resource.primarySector
            ? _c("li", { staticClass: "col-12 col-md-3 detail" }, [
                _c("span", { staticClass: "label" }, [_vm._v("Main Sector")]),
                _vm._v(" "),
                _c("span", { staticClass: "sector" }, [
                  _vm._v(_vm._s(_vm.resource.primarySector.name)),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.resource.sectors
            ? _c(
                "li",
                { staticClass: "col-12 col-md-9 detail" },
                [
                  _c("span", { staticClass: "label" }, [_vm._v("Sectors")]),
                  _vm._v(" "),
                  _vm._l(_vm.resource.sectors, function (sector) {
                    return _c("span", { staticClass: "sector" }, [
                      _vm._v(_vm._s(sector.name)),
                    ])
                  }),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.resource.currencyInitial
            ? _c("li", { staticClass: "col-6 col-md-3 detail" }, [
                _c("span", { staticClass: "label" }, [_vm._v("Currency")]),
                _vm._v(" "),
                _c(
                  "strong",
                  [
                    _c("SvgIcon", { attrs: { icon: "money" } }),
                    _vm._v(" " + _vm._s(_vm.resource.currencyInitial)),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.resource.companyRevenue
            ? _c("li", { staticClass: "col-6 col-md-3 detail" }, [
                _c("span", { staticClass: "label" }, [_vm._v("Revenue")]),
                _vm._v(" "),
                _c(
                  "strong",
                  [
                    _c("SvgIcon", { attrs: { icon: "value" } }),
                    _vm._v(" " + _vm._s(_vm.resource.companyRevenue) + "m"),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.resource.projectedValueFrom && _vm.resource.projectedValueTo
            ? _c("li", { staticClass: "col-6 col-md-3 detail" }, [
                _c("span", { staticClass: "label" }, [
                  _vm._v("Projected transaction value"),
                ]),
                _vm._v(" "),
                _c(
                  "strong",
                  [
                    _c("SvgIcon", { attrs: { icon: "value" } }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.resource.projectedValueFrom) +
                        "m-" +
                        _vm._s(_vm.resource.projectedValueTo) +
                        "m"
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("Accordion", {
        attrs: { items: _vm.formatAccordionData(), "start-open": true },
      }),
      _vm._v(" "),
      _vm.resource.documents && _vm.resource.documents.length
        ? _c(
            "div",
            {
              staticClass: "card accordion__item",
              staticStyle: { "margin-top": "2rem" },
            },
            [
              _c("h3", { staticClass: "accordion__title" }, [
                _vm._v("Attachments"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "accordion__copy",
                  staticStyle: { height: "auto" },
                },
                [
                  _vm.resource.documents.length
                    ? _c(
                        "ul",
                        { staticClass: "documents" },
                        _vm._l(_vm.resource.documents, function (doc) {
                          return _c(
                            "li",
                            [
                              _c("AttachmentDownload", {
                                attrs: { attachment: doc },
                              }),
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("section", { staticClass: "grid" }, [
        _c("div", { staticClass: "col-12 col-md-8 order-2 order-md-1" }, [
          _c(
            "div",
            { staticClass: "card" },
            [
              _vm.resource.can.respond
                ? [
                    _c("OpportunityResponseForm", {
                      ref: "responseForm",
                      attrs: { opportunity: _vm.resource.id },
                      on: {
                        submitted: _vm.addResponse,
                        update: _vm.updateResponse,
                      },
                    }),
                    _vm._v(" "),
                    _c("hr"),
                  ]
                : _vm.resource.can.feedback
                ? [
                    _c("OpportunityFeedbackForm", {
                      ref: "feedbackForm",
                      attrs: { opportunity: _vm.resource.id },
                      on: { submitted: _vm.addFeedback },
                    }),
                    _vm._v(" "),
                    _c("hr"),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.resource.feedback
                ? [
                    _c("div", { staticClass: "header" }, [
                      _vm._v("Feedback "),
                      _c("span", { staticClass: "notification" }, [
                        _vm._v("!"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.resource.feedback))]),
                    _vm._v(" "),
                    _c("hr"),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "header" }, [
                _vm._v("Able to help "),
                _c("span", { staticClass: "notification" }, [_vm._v("!")]),
              ]),
              _vm._v(" "),
              _vm._l(_vm.ableToHelp, function (response) {
                return _c("Response", {
                  key: response.id,
                  ref: "ableToHelp",
                  refInFor: true,
                  attrs: { response: response },
                  on: {
                    "response:deleted": _vm.responseDeleted,
                    "response:edit": _vm.populateForm,
                  },
                })
              }),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("div", { staticClass: "header" }, [
                _vm._v("Unable to help "),
                _c("span", { staticClass: "notification" }, [_vm._v("!")]),
              ]),
              _vm._v(" "),
              _vm._l(_vm.unableToHelp, function (response) {
                return _c("Response", {
                  key: response.id,
                  ref: "unableToHelp",
                  refInFor: true,
                  attrs: { response: response },
                  on: {
                    "response:deleted": _vm.responseDeleted,
                    "response:edit": _vm.populateForm,
                  },
                })
              }),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 col-md-4 order-1 order-md-2" },
          [
            _vm.resource.member
              ? _c("MemberCard", { attrs: { member: _vm.resource.member } })
              : _vm._e(),
            _vm._v(" "),
            _vm.resource.lead
              ? _c(
                  "div",
                  { staticClass: "profile-list" },
                  [
                    _c("p", { staticClass: "profile-list__title" }, [
                      _vm._v("Lead User"),
                    ]),
                    _vm._v(" "),
                    _c("UserCard", {
                      attrs: { user: _vm.resource.lead, borderless: true },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.filterLead(_vm.resource.team).length
              ? _c(
                  "div",
                  { staticClass: "profile-list" },
                  [
                    _c("p", { staticClass: "profile-list__title" }, [
                      _vm._v("Users also involved"),
                    ]),
                    _vm._v(" "),
                    _vm._l(
                      _vm.filterLead(_vm.resource.team),
                      function (profile) {
                        return _c("UserCard", {
                          key: profile.id,
                          attrs: {
                            user: profile,
                            borderless: true,
                            small: true,
                          },
                        })
                      }
                    ),
                  ],
                  2
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }